import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface ToggleSemanticStyles {
  on: string;
  off: string;

  'on-disabled': string;
  'off-disabled': string;

  selected: string;
}

export const lightToggleSemanticStyles: ToggleSemanticStyles = {
  on: colorPrimitive.blue[600],
  off: colorPrimitive.gray[700],

  'on-disabled': colorPrimitive.blue[300],
  'off-disabled': colorPrimitive.gray[300],

  selected: colorPrimitive.alpha.black.black200,
} as const satisfies ToggleSemanticStyles;

export const redesignedLightToggleSemanticStyles: ToggleSemanticStyles = {
  ...lightToggleSemanticStyles,
  on: colorPrimitive.blurple[600],
  'on-disabled': colorPrimitive.blurple[300],
} as const satisfies ToggleSemanticStyles;

export const darkToggleSemanticStyles: ToggleSemanticStyles = {
  on: colorPrimitive.blue[500],
  off: colorPrimitive.gray[600],

  'on-disabled': colorPrimitive.blue[700],
  'off-disabled': colorPrimitive.gray[700],

  selected: colorPrimitive.alpha.white.white200,
} as const satisfies ToggleSemanticStyles;

export const redesignedDarkToggleSemanticStyles: ToggleSemanticStyles = {
  ...darkToggleSemanticStyles,
  on: colorPrimitive.blurple[500],
  'on-disabled': colorPrimitive.blurple[700],
} as const satisfies ToggleSemanticStyles;
